// @ts-strict-ignore
import { EventEmitter, Injectable } from '@angular/core';
import { ReportVO } from '@project/model/vo/report.vo';
import { CSVColumn } from '../service/select-project-report.service';

export enum CsvMode {
  Grouped = 'grouped',
  ByPositionGroupedWithoutAccessories = 'by_position_grouped_without_accessories',
  ByPositionWithAccessories = 'by_position_with_accessories',
  ByPositionWithoutAccessories = 'by_position_without_accessories'
}

export class CsvModeUtil {
  public static isValid(value: string): boolean {
    return (Object.values(CsvMode) as string[]).includes(value);
 }

 public static toEnum(value: string): CsvMode|undefined {
    return this.isValid(value) ? value as CsvMode : undefined;
 }
}

@Injectable({ providedIn: 'root' })
export class SelectProjectReportModel {

  public get isCSV(): boolean {
    return this.type
      ? ReportVO.TYPE_CSV === this.type
      : null;
  }

  public readonly paperSizeKeys: string[] = ['a2', 'a3', 'a4', 'letter', 'dsize'];
  public readonly scaleKeys: number[] = [1, 2, 5];
  public readonly orderNumbersKeys: string[] = ['wago_numbers', 'custom_numbers', 'owner_custom_numbers', 'no_numbers'];
  public readonly customOrderNumbersKey: string = 'custom_numbers';
  public readonly encodingKeys: string[] = ['Windows-1252', 'UTF-8'];

  public reports: ReportVO[] = [];
  public csvColumnsList: CSVColumn[] = [];
  public type: string;
  public isPrintSettingsAvailable: boolean = true;
  public canSeeInternalComments: boolean;
  public nextButtonEnabled: boolean;
  public saveSettings: boolean = true;
  public csvConfirm = new EventEmitter();
  public pdfConfirm = new EventEmitter();
  public documentCreationConfirm = new EventEmitter();

  public multipleProjectReport: boolean;
  public readonly dataStructureGroup: string[] = ['selectProjectReportPopup.option.append', 'selectProjectReportPopup.option.sum'];
  public dataStructureGroupSelected: string;
  public dataStructureGroupDisabled: boolean = true;
  public encodinGroupSelected: string;
  public paperSizeListSelected: string;
  public usedNumbersGroupSelected: string;
  public includeRemarks: boolean;
  public includeInternalRemarks: boolean;
  public includeInternalOptions: boolean;
  public includeArticleNumberLong: boolean;
  public includeDocumentVersion: boolean;
  public includeProjectVersion: boolean;
  public useIds: boolean;
  public isBorderVisible: boolean;

  public isDisplayOfProjectStructureEnabled: boolean;

  public selectedCsvMode: CsvMode;

  public get isGroupedCsvReport(): boolean {
    return this.isCSV && this.selectedCsvMode === CsvMode.Grouped;
  }

  public get isDiscreteCsvReport(): boolean {
    return this.isCSV && (
      this.selectedCsvMode === CsvMode.ByPositionGroupedWithoutAccessories ||
      this.selectedCsvMode === CsvMode.ByPositionWithAccessories ||
      this.selectedCsvMode === CsvMode.ByPositionWithoutAccessories);
  }
}
